import { render, staticRenderFns } from "./IconCredit.vue?vue&type=template&id=3e3300c4&"
import script from "./IconCredit.vue?vue&type=script&lang=js&"
export * from "./IconCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports